// 轻量 i18n:内置 zh-CN / en-US 翻译表 + localStorage 记忆 + React Context
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import zh from './zh-CN';
import en from './en-US';

const DICTS = { 'zh-CN': zh, 'en-US': en };
const STORAGE_KEY = 'meowapi_lang';

function detectInitial() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && DICTS[saved]) return saved;
    const nav = (navigator.language || 'zh-CN').toLowerCase();
    if (nav.startsWith('en')) return 'en-US';
  } catch {}
  return 'zh-CN';
}

const I18nContext = createContext({
  lang: 'zh-CN',
  setLang: () => {},
  t: (key, fallback) => fallback || key,
});

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectInitial);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const dict = DICTS[lang] || zh;
    const resolve = (key) => {
      if (key == null) return undefined;
      const v = dict[key];
      if (v !== undefined) return v;
      const base = zh[key];
      if (base !== undefined) return base;
      return undefined;
    };
    const t = (key, fallback, vars) => {
      let s = resolve(key);
      if (s === undefined) s = fallback != null ? fallback : String(key);
      if (vars && typeof s === 'string') {
        s = s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? String(vars[k]) : m));
      }
      return s;
    };
    return { lang, setLang: setLangState, t };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
export const useT = () => useContext(I18nContext).t;